export default "__VITE_PUBLIC_ASSET__ff69ba3d__"